import React from "react";
import { EyeOff, Lock } from "lucide-react";
import { cn } from "@/lib/utils";

interface LicensePlateProps {
    lpn?: string;
    className?: string;
}

export const LicensePlate: React.FC<LicensePlateProps> = ({ lpn, className }) => {
    if (!lpn) return null;
    return (
        <span
            className={`inline-flex items-center bg-white text-black border border-l-4 sm:border-l-8 border-blue border-blue-600 rounded font-mono text-[11px] md:text-sm select-none pl-1 pr-0.5 sm:pl-2 sm:pr-1 py-0.5 sm:py-0 ${className || ''}`}
            style={{ letterSpacing: '0.1em' }}
        >
            {lpn}
        </span>
    );
};

/** Blurred plate tease for guests — hover/title explains login is required. */
export const GuestLicensePlateTease: React.FC<{
  className?: string;
  title?: string;
  onLoginClick?: (e: React.MouseEvent) => void;
}> = ({
  className,
  title = "Logga in för att se registreringsnummer",
  onLoginClick,
}) => (
  <button
    type="button"
    title={title}
    aria-label={title}
    onClick={(e) => {
      e.stopPropagation();
      onLoginClick?.(e);
    }}
    className={cn(
      "relative inline-flex items-center overflow-hidden rounded border border-l-4 sm:border-l-8 border-blue-600 bg-white select-none pl-1 pr-0.5 sm:pl-2 sm:pr-1 py-0.5 sm:py-0 cursor-pointer",
      className,
    )}
  >
    <span
      className="font-mono text-[11px] md:text-sm text-black/80 blur-[3.5px] pointer-events-none"
      style={{ letterSpacing: "0.1em" }}
      aria-hidden
    >
      ABC12D
    </span>
    <span className="absolute inset-0 flex items-center justify-center gap-0.5 bg-black/25">
      <Lock className="h-2.5 w-2.5 text-white drop-shadow" strokeWidth={2.5} />
      <EyeOff className="h-2.5 w-2.5 text-white drop-shadow" strokeWidth={2.5} />
    </span>
  </button>
); 